<template>
  <div>
    <div class="a-die a-die--warning" v-if="lot.state.RETEND || lot.state.WAITING_FOR_RETEND">
      <div class="a-die__container u-text-left">
        <div class="a-tab__title-block admin__a-tab u-border-0">
          <div class="a-container-form " v-if="nextRetendRequestTimeLeft && retendTimeLeft">
            <div class="a-label a-col-label a-label--w-280">{{$t('form.lot.due-date-for-next-bid')}}:</div>
            <div class="a-col-block-content ">
              <timer :value="nextRetendRequestTimeLeft"></timer>
            </div>
          </div>
          <div class="a-container-form u-padding-bottom-0" v-if="retendTimeLeft && nextRetendRequestTimeLeft">
            <div class="a-label a-col-label a-label--w-280">{{$t('form.lot.time-left-to-retend-finish')}}:</div>
            <div class="a-col-block-content ">
              <timer :value="retendTimeLeft"></timer>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="a-group-btn">
      <div class="a-group-btn__left">
        <button class="gui-btn gui-btn--white-border gui-btn--w-184"
                @click.prevent="onDownloadFinishListClick"
                v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_DOWNLOAD_FINISH_LIST">{{$t('buttons.download-reduction-final-list')}}</button>
        <!--<button class="gui-btn gui-btn&#45;&#45;white-border gui-btn&#45;&#45;w-184">Организовать переторжку</button>-->
        <!--<button class="gui-btn gui-btn&#45;&#45;white-border gui-btn&#45;&#45;w-184">Сформировать протокол</button>-->
      </div>
      <div class="a-group-btn__right">
        <button class="gui-btn gui-btn--red gui-btn--w-184" @click.prevent="$refs.miniReport.show()">{{$t('buttons.open-mini-report')}}</button>
      </div>
    </div>

    <org-report :lot="lot" v-if="user.permissions.IS_MTS_USER"></org-report>
    <mini-report :lot="lot" ref="miniReport"></mini-report>
  </div>
</template>

<script>
  import OrgReport from './org-report/Report'
  import MiniReport from './MiniReport'

  import TimerMixins from '../mixins/timers'

  export default {
    props: {
      lot: Object
    },

    components: {
      OrgReport,
      MiniReport
    },

    mixins: [
      TimerMixins
    ],

    computed: {
      user() {
        return this.$store.getters.currentUser;
      },
    },

    methods: {
      async onDownloadFinishListClick() {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('exportReductionFinishList', {
              lotId: this.lot.id
            })
          }
          catch(e) {
            console.error('unable to download reduction finish list', e);
            this.globalErrorHandler(e);
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>

